<template>
    <div class="changewarp">
        <Header title="创新学分"></Header>
        <div class="changecontent">
            <div class="header">
                <div class="ht">
                    <div class="name">{{ this.xm }}</div>
                    <div class="num">({{ this.xh }})</div>
                </div>
                <div class="hb">
                    <div>年级：{{ this.xsnj }}</div>
                    <div>班级：{{ this.bj }}</div>
                </div>
            </div>
            <div class="list">
                <div class="listBox">
                    <div class="package">
                        <div class="tableBox" style="padding:12px 15px">
                            <el-table :data="tableData" fit border style="width: 100%;" :header-cell-style="{ background: '#E1E4E9' }">
                                <el-table-column type="index" width="50"> </el-table-column>
                                <el-table-column prop="xqmc" label="学年学期"></el-table-column>
                                <el-table-column prop="hdmc" label="活动名称">
                                    <template slot-scope="scope">
                                        <div @click="showPopup(scope.row)">{{ scope.row.hdmc }}</div>
                                        <van-popup v-model="show" closeable round>
                                            <div class="springFrame">
                                                <div class="title">{{ choiceItem.hdmc }}</div>
                                                <ul>
                                                    <li>学号:{{ choiceItem.xh }}</li>
                                                    <li>姓名：{{ choiceItem.xm }}</li>
                                                    <li>学年学期：{{ choiceItem.xqmc }}</li>
                                                    <li>活动类型：{{ choiceItem.hdlx }}</li>
                                                    <li>活动名称：{{ choiceItem.hdmc }}</li>
                                                    <li>所获学分：{{ choiceItem.cxxf }}</li>
                                                    <li>负责人：{{ choiceItem.fzr }}</li>
                                                    <li>报告人：{{ choiceItem.bgr }}</li>
                                                    <li>录入时间：{{ choiceItem.lrsj }}</li>
                                                    <li>备注：{{ choiceItem.bz }}</li>
                                                </ul>
                                                <button @click="show = false">知道了</button>
                                            </div>
                                        </van-popup>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="cxxf" label="所获学分"> </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Api } from '../../../../utils/axios';

export default {
    data() {
        return {
            tableData: [],
            show: false,
            xsydList: '',
            xm: '',
            xh: '',
            xsnj: '',
            bj: '',
            choiceItem: {}
        };
    },
    created() {
        this.xsydList = this.$route.query.xs0101id;
        this.xm = this.$route.query.xm;
        this.xh = this.$route.query.xh;
        this.xsnj = this.$route.query.xsnj;
        this.bj = this.$route.query.bj;
        //列表接口
        this.getCxxfcjQuery();
    },
    methods: {
        //弹框
        showPopup(row) {
            this.choiceItem = row;
            this.show = true;
        },
        //列表接口
        async getCxxfcjQuery() {
            const params = {
                xs0101id: this.xsydList
            };
            const res = await Api.getCxxfcjQuery(params);
            this.tableData = res.data;
        }
    }
};
</script>

<style scoped lang="less">
.changewarp {
    .changecontent {
        .header {
            .ht {
                display: flex;
                font-family: PingFangSC-Medium;
                font-weight: 500;
                font-size: 16px;
                color: #333333;
                margin-left: 26px;
            }
            .hb {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 14px;
                color: #999999;
                margin-top: 5px;
                margin-left: 24px;
                padding-bottom: 12px;
                div {
                    padding: 5px 7px 0 0px;
                }
            }
        }
        .list {
            width: 100%;
            height: 100vh;
            background: #f6f6f6;
            .listBox {
                width: 100%;
                display: flex;
                justify-content: center;
                align-content: center;
                .package {
                    width: 100%;
                    background: #ffffff;
                    margin-top: 10px;
                    .gradeBox {
                        display: flex;
                        justify-content: center;
                        align-content: center;
                        padding: 15px 0;
                        .jiantou {
                            display: inline-block;
                            border-bottom: 1px solid;
                            border-left: 1px solid;
                            width: 5px;
                            height: 5px;
                            border-color: #b2b2b2;
                            transform: rotate(-45deg);
                            transition: all 0.4s ease;
                            margin: 3px;
                        }
                    }
                }
            }
        }
    }
}
</style>
<style lang="less">
.tableBox {
    .el-table {
        .el-table__body-wrapper {
            tbody {
                tr {
                    td:nth-child(3) {
                        .cell {
                            color: #0189f9;
                        }
                        .springFrame {
                            width: 100%;
                            height: 100%;
                            .title {
                                font-weight: 500;
                                font-size: 18px;
                                color: #333333;
                                line-height: 18px;
                                margin: 20px;
                            }
                            ul {
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;
                                line-height: 21px;
                                margin: 10px 20px;
                                li {
                                    margin: 2px 0;
                                }
                                .newli {
                                    font-weight: 500;
                                    color: #333333;
                                }
                            }
                            button {
                                width: 271px;
                                height: 42px;
                                background: #0189f9;
                                border-radius: 4px;
                                color: #ffffff;
                                margin: 20px;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/informationService/innovationCredits.vue